


















































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";

import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { IGuest, IDocType, IAdditionalPhone } from "@/@types/admin/guest/user";
import { required, email } from "vuelidate/lib/validators";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { calculateAge as getAge } from "@/services/dateTime/ages";

import intlTelInput from "intl-tel-input";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import LightGuestList from "@/components/tables/administration/guests/light-guest-list.vue";
import RoomDd from "@/components/app/dropdowns/rooma/room-dd.vue";
import Document0 from "./document_types/document0.vue";
import Document2 from "./document_types/document2.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import Document4 from "./document_types/document4.vue";
import Document8 from "./document_types/document8.vue";
import Document from "./document_types/document.vue";
import Citizenship from "@/components/app/citizenship.vue";

import identity_cards from "@/config/identity/identity_cards";
import "vue2-datepicker/locale/ru";
import "vue2-datepicker/locale/en";

interface ITimepicker {
  HH: string;
  mm: string;
}

@Component({
  mixins: [validationMixin],
  validations: {
    full_name: { required },
    birthday: { required },
    number: { required },
    email: { email },
    arrival: { required },
    departure: { required },
  },
  components: {
    StandartModal,
    SubmitResetButtonGroop,
    LightGuestList,
    VueTimepicker,
    Citizenship,
    DatePicker,
    Document0,
    Document2,
    Document4,
    Document8,
    Document,
    RoomDd,
  },
})
export default class AddGuestForm extends Vue {
  @Prop({ type: Array, default: () => [] }) guests!: Array<IGuest>;
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;
  @Prop({ type: Array, default: () => [] }) roomLevels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomTypes!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomStatuses!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) virtualRooms!: Array<IVirtualRooma>;
  @Prop({ type: Object, default: null }) item!: IGuest | null;
  @Prop({ type: String, default: "" }) shipCode!: string;
  @Prop({ type: String, default: "" }) room!: string;
  docTypes: Array<IDocType> = identity_cards;
  full_name = "";

  first_name = "";
  surname = "";
  second_name = "";
  birthday: string | Date | null = null;
  document = this.docTypes[0]._id;
  number = "";
  document_data: Date | string = "";

  comment = "";
  gender = 0;
  citizenship = "";

  phoneModel = "";
  phone_internet_access = "";
  verification_code = "";
  email = "";

  roomNumber = this.room ? this.room : "";
  orderNumber = "";
  arrival: string | Date | null = null;
  departure: string | Date | null = null;
  agent = "";

  customerName = "";
  customerPhone = "";

  showRoomHelp = false;
  arrivaltime: ITimepicker | null = null;
  departuretime: ITimepicker | null = null;

  aphonenumber = "";
  aphonename = "";
  secondPhones: Array<IAdditionalPhone> = [];

  $refs!: {
    phoneNumber: HTMLInputElement;
    customerPhone: HTMLInputElement;
  };

  get getDocType(): string {
    if (this.document == "0") return "document0";
    if (this.document == "2") return "document2";
    if (this.document == "4" || this.document == "11") return "document4";
    if (this.document == "8") return "document8";
    return "document";
  }

  get guest(): Partial<IGuest> {
    return {
      _id: this.item ? this.item._id : "",
      comment: this.comment,
      personal_data: {
        first_name: this.first_name,
        surname: this.surname,
        second_name: this.second_name,
        birthday: this.birthday,
        gender: this.gender,
        nationality: this.citizenship,
        documents: {
          doctype: this.document,
          serial: "",
          number: this.number,
          data: this.document_data,
        },
      },
      additional_data: {
        phone_number: this.phoneModel,
        additional_phone_number: this.secondPhones,
        phone_internet_access: this.phone_internet_access,
        verification_code: this.verification_code,
        email: this.email,
        consent: { phone: true, email: true, phone_internet_access: true }, // Разрешение на обработку данных
        internet_access: this.item
          ? this.item.additional_data.internet_access
          : [],
      },
      stay_data: {
        cruise_code: "",
        hotel_name: this.shipCode,
        room: { number: this.getRoom, id: this.roomNumber },
        order_number: this.orderNumber,
        arrival: this.arrival,
        departure: this.departure,
        agent: this.agent, // агент, у которого приобретен заказ
        customer: {
          name: this.customerName, // todo: can be an object {first_name, surname, second_name, ...}
          phone_number: this.customerPhone,
          comments: this.comment,
        },
      },
    };
  }

  get newGuests(): Array<IGuest> {
    return this.guests.filter((guest) => {
      const vrooma = this.virtualRooms.find((vr) =>
        vr.guests.includes(guest._id)
      );
      if (!vrooma || !vrooma.room) return guest;
    });
  }

  get getRoom(): string {
    const room = this.rooms.find((r) => r._id == this.roomNumber);
    return room ? room.name : "";
  }

  get getDocument(): IDocType | null {
    const document = this.docTypes.find((doc) => doc._id == this.document);
    return document ? document : null;
  }

  get age(): number {
    if (this.birthday) return getAge(this.birthday);
    return -1;
  }

  @Watch("arrivaltime", { deep: true })
  updatearrivaltime(): void {
    if (!this.arrival || !this.arrivaltime) return;
    const date = new Date(this.arrival);
    date.setMinutes(Number(this.arrivaltime.mm));
    date.setHours(Number(this.arrivaltime.HH));
    this.arrival = date;
  }

  @Watch("departuretime", { deep: true })
  updatedeparturetime(): void {
    if (!this.departure || !this.departuretime) return;
    const date = new Date(this.departure);
    date.setMinutes(Number(this.departuretime.mm));
    date.setHours(Number(this.departuretime.HH));
    this.departure = date;
  }

  @Watch("age")
  updateDocType(): void {
    if (this.age < 0) {
      this.document = "0";
      return;
    }
    if (this.age < 14 && this.document == "0") this.document = "4";
    if (this.age >= 14 && this.document == "4") this.document = "0";
  }

  @Watch("arrival")
  setArrival(): void {
    if (!this.arrival) return;
    sessionStorage.setItem("guest-arrival", String(this.arrival));
    if (this.arrivaltime) return;
    const arival = new Date(this.arrival);
    const minutes = arival.getMinutes();
    if (this.arrivaltime)
      this.arrivaltime = {
        HH: String(arival.getHours()),
        mm: String(minutes < 10 ? `0${minutes}` : minutes),
      };
  }

  @Watch("departure")
  setDeparture(): void {
    if (!this.departure) return;
    sessionStorage.setItem("guest-departure", String(this.departure));
    if (this.departuretime) return;
    const departure = new Date(this.departure);
    const minutes = departure.getMinutes();
    this.departuretime = {
      HH: String(departure.getHours()),
      mm: String(minutes < 10 ? `0${minutes}` : minutes),
    };
  }

  @Watch("room")
  createWoomNubmer(): void {
    if (this.room) this.roomNumber = this.room;
  }

  @Watch("roomNumber")
  closeRoomHelper(): void {
    this.showRoomHelp = false;
  }

  addSecondPhone(): void {
    if (!this.aphonename || !this.aphonenumber) return;
    this.secondPhones.push({
      phone_number: this.aphonenumber,
      name: this.aphonename,
    });
    this.aphonename = "";
    this.aphonenumber = "";
  }

  changeRoom(roomNumber: string): void {
    this.roomNumber = roomNumber === "*" ? "" : roomNumber;
    if (roomNumber != "*") this.$bvModal.hide("room-list");
  }

  @Watch("full_name")
  createName(): void {
    const name = this.full_name.trim().replace(/\s+/g, " ");
    const names = name.split(" ");
    if (!names.length) {
      this.full_name = "";
      return;
    }
    this.surname = names[0] ? names[0] : "";
    this.first_name = names[1] ? names[1] : "";
    this.second_name = names[2] ? names[2] : "";
  }

  isValidDate(d: number | string | Date | null): boolean {
    if (String(new Date(String(d))) == "Invalid Date") return false;
    return true;
  }

  newdateFormCreater(date: string | Date): string {
    const now = new Date(date);
    const day = ("0" + now.getDate()).slice(-2);
    const month = ("0" + (now.getMonth() + 1)).slice(-2);
    const today = now.getFullYear() + "-" + month + "-" + day;
    return today;
  }

  @Watch("item")
  createGuest(): void {
    if (!this.item) return;
    // docs_type = ''

    this.first_name = this.item.personal_data?.first_name
      ? this.item.personal_data?.first_name
      : "";
    this.surname = this.item.personal_data?.surname
      ? this.item.personal_data?.surname
      : "";
    this.second_name = this.item.personal_data?.second_name
      ? this.item.personal_data?.second_name
      : "";

    this.full_name = `${this.surname} ${this.first_name} ${this.second_name}`;

    if (this.item.personal_data) {
      this.birthday = this.isValidDate(this.item.personal_data.birthday)
        ? new Date(String(this.item.personal_data.birthday))
        : null;

      if (this.item.personal_data.documents) {
        const docdate = this.item.personal_data.documents.data;
        this.document_data = this.isValidDate(docdate)
          ? new Date(String(docdate))
          : "";
      }
      this.citizenship = this.item.personal_data.nationality
        ? this.item.personal_data.nationality
        : "";
    }

    this.document = this.item.personal_data?.documents?.doctype
      ? this.item.personal_data?.documents?.doctype
      : "";
    const serial = this.item.personal_data?.documents?.serial
      ? this.item.personal_data?.documents?.serial
      : "";
    this.number = this.item.personal_data?.documents?.number
      ? this.item.personal_data?.documents?.number
      : "";
    this.number = serial + this.number;

    this.comment = this.item.comment ? this.item.comment : "";
    this.phoneModel =
      this.item.additional_data?.phone_number &&
      parseInt(this.item.additional_data?.phone_number)
        ? this.item.additional_data?.phone_number
        : "";
    this.phone_internet_access =
      this.item.additional_data &&
      this.item.additional_data.phone_internet_access
        ? this.item.additional_data?.phone_internet_access
        : "";
    this.verification_code =
      this.item.additional_data && this.item.additional_data.verification_code
        ? this.item.additional_data?.verification_code
        : "";

    this.email = this.item.additional_data?.email
      ? this.item.additional_data?.email
      : "";

    this.secondPhones = this.item.additional_data?.additional_phone_number
      ? this.item.additional_data?.additional_phone_number
      : [];

    this.roomNumber = this.room
      ? this.room
      : this.item.stay_data?.room
      ? this.item.stay_data?.room.id
      : "";
    this.orderNumber = this.item.stay_data?.order_number
      ? this.item.stay_data?.order_number
      : "";

    if (this.item.stay_data) {
      this.arrival = this.isValidDate(this.item.stay_data.arrival)
        ? new Date(String(this.item.stay_data.arrival))
        : null;
      if (this.arrival) {
        const minutes = this.arrival.getMinutes();
        this.arrivaltime = {
          HH: String(this.arrival.getHours()),
          mm: String(minutes < 10 ? `0${minutes}` : minutes),
        };
      }
      this.departure = this.isValidDate(this.item.stay_data?.departure)
        ? new Date(String(this.item.stay_data?.departure))
        : null;
      if (this.departure) {
        const minutes = this.departure.getMinutes();
        this.departuretime = {
          HH: String(this.departure.getHours()),
          mm: String(minutes < 10 ? `0${minutes}` : minutes),
        };
      }
    }

    this.agent = this.item.stay_data?.agent ? this.item.stay_data?.agent : "";
    this.customerName = this.item.stay_data?.customer?.name
      ? this.item.stay_data?.customer.name
      : "";
    this.customerPhone =
      this.item.stay_data?.customer?.phone_number &&
      parseInt(this.item.stay_data?.customer?.phone_number)
        ? this.item.stay_data?.customer?.phone_number
        : "";
    this.gender = this.item.personal_data?.gender
      ? this.item.personal_data?.gender
      : 0;
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    if (!this.roomNumber) this.showRoomHelp = true;
    if (this.$v.$invalid) {
      this.$v.$touch();
      console.log("invalid");
      return;
    }
    if (!this.birthday) return console.log("!birthday");
    if (!this.arrival) return console.log("!arrival");
    if (!this.departure) return console.log("!departure");
    if (!this.roomNumber) return console.log("!roomNumber");

    const id = this.item ? this.item._id : "";
    if (id) this.$emit("changeGuest", this.guest, id, true);
    else this.$emit("addNewGuest", this.guest, true);
  }

  onSeve(event: Event): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      console.log("invalid");
      return;
    }
    if (!this.birthday) return console.log("!birthday");
    if (!this.arrival) return console.log("!arrival");
    if (!this.departure) return console.log("!departure");

    const id = this.item ? this.item._id : "";
    console.log("valid: " + id);

    if (id) this.$emit("changeGuest", this.guest, id, false);
    else this.$emit("addNewGuest", this.guest, false);
  }

  onReset(): void {
    this.full_name = "";
    this.first_name = "";
    this.surname = "";
    this.second_name = "";
    this.birthday = null;
    this.document = this.docTypes[0]._id;
    this.number = "";
    this.document_data = "";
    this.email = "";

    this.roomNumber = "";
    this.orderNumber = "";
    this.arrival = null;
    this.departure = null;
    this.agent = "";
    this.comment = "";
    this.customerName = "";
    this.phone_internet_access = "";
    this.gender = 0;

    this.phoneModel = "";
    this.verification_code = "";
    this.customerPhone = "";
    this.showRoomHelp = false;
    this.arrivaltime = null;
    this.departuretime = null;
    this.secondPhones = [];
    this.aphonename = "";
    this.aphonenumber = "";
  }

  iti_phone: any = null;
  iti_cust_phone: any = null;

  itiInit(): void {
    const input = this.$refs.phoneNumber;
    if (!input) return;

    this.iti_phone = intlTelInput(input, {
      initialCountry: "ru",
      preferredCountries: ["ru"],
      hiddenInput: "full_phone",
    });

    const customerinput = this.$refs.customerPhone;
    if (!customerinput) return;
    this.iti_cust_phone = intlTelInput(customerinput, {
      initialCountry: "ru",
      preferredCountries: ["ru"],
      hiddenInput: "full_phone",
    });
  }

  show(): void {
    setTimeout(() => {
      this.itiInit();
      this.createGuest();
      this.autoStayDate();
    }, 200);
  }

  autoStayDate(): void {
    this.$nextTick(() => {
      let arrival: string | Date | null =
        sessionStorage.getItem("guest-arrival");
      let departure: string | Date | null =
        sessionStorage.getItem("guest-departure");
      if (arrival) {
        arrival = new Date(arrival);
        this.arrival = arrival;
        const minutes = arrival.getMinutes();
        this.arrivaltime = {
          HH: String(arrival.getHours()),
          mm: String(minutes < 10 ? `0${minutes}` : minutes),
        };
      }

      if (departure) {
        departure = new Date(departure);
        this.departure = departure;
        const minutes = departure.getMinutes();
        this.departuretime = {
          HH: String(departure.getHours()),
          mm: String(minutes < 10 ? `0${minutes}` : minutes),
        };
      }
    });
  }

  mounted(): void {
    this.$nextTick(() => {
      this.autoStayDate();
      this.createGuest();
      this.itiInit();
    });
  }

  destroyed(): void {
    this.onReset();
  }
}
